(function () {
  if (window.L4DeferredVideo) return;

  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var registeredVideos = new Set();
  var observedVideos = new WeakSet();
  var loadObserver = null;
  var playObserver = null;

  function isMobile() {
    return mobileQuery.matches;
  }

  function getPreloadDistance() {
    var minimumDistance = isMobile() ? 1400 : 900;
    var viewportMultiplier = isMobile() ? 2 : 1.25;
    return Math.max(minimumDistance, Math.round(window.innerHeight * viewportMultiplier));
  }

  function getDataValue(video, mobileKey, desktopKey) {
    if (isMobile() && video.dataset[mobileKey]) return video.dataset[mobileKey];
    return video.dataset[desktopKey] || video.dataset[mobileKey] || '';
  }

  function prepare(video) {
    if (!video) return;

    var src = getDataValue(video, 'videoSrcMobile', 'videoSrcDesktop');
    if (!src) return;
    if (video.dataset.videoLoaded === 'true' && video.dataset.videoSelectedSrc === src) return;

    var poster = getDataValue(video, 'videoPosterMobile', 'videoPosterDesktop');
    if (poster) video.poster = poster;

    video.preload = 'auto';
    video.src = src;
    video.dataset.videoSelectedSrc = src;
    video.dataset.videoLoaded = 'true';
    video.load();
  }

  function pause(video) {
    if (!video) return;
    video.dataset.videoShouldPlay = 'false';
    if (!video.paused) video.pause();
  }

  function play(video) {
    if (!video || reducedMotionQuery.matches || document.hidden) return;

    video.dataset.videoShouldPlay = 'true';
    prepare(video);
    if (video.dataset.videoLoaded !== 'true') return;

    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function isInViewport(video) {
    var rect = video.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
  }

  function createObservers() {
    if (!('IntersectionObserver' in window)) return;

    var preloadDistance = getPreloadDistance();
    loadObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        prepare(entry.target);
        loadObserver.unobserve(entry.target);
      });
    }, {
      rootMargin: preloadDistance + 'px 0px',
      threshold: 0
    });

    playObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.1) {
          play(entry.target);
        } else {
          pause(entry.target);
        }
      });
    }, {
      threshold: [0, 0.1]
    });
  }

  function register(video) {
    if (!video || observedVideos.has(video)) return;

    observedVideos.add(video);
    registeredVideos.add(video);

    if (video.hasAttribute('data-video-manual')) return;

    if (loadObserver && playObserver) {
      loadObserver.observe(video);
      playObserver.observe(video);
      return;
    }

    prepare(video);
    play(video);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('video[data-deferred-video]').forEach(register);
  }

  function rebuildObservers() {
    if (!('IntersectionObserver' in window)) return;

    registeredVideos.forEach(function (video) {
      if (video.dataset.videoLoaded !== 'true') return;

      var shouldResume = video.dataset.videoShouldPlay === 'true';
      prepare(video);
      if (shouldResume) play(video);
    });

    if (loadObserver) loadObserver.disconnect();
    if (playObserver) playObserver.disconnect();
    loadObserver = null;
    playObserver = null;
    observedVideos = new WeakSet();
    createObservers();
    scan(document);
  }

  window.L4DeferredVideo = {
    prepare: prepare,
    play: play,
    pause: pause,
    scan: scan,
    isInViewport: isInViewport,
    getPreloadDistance: getPreloadDistance
  };

  createObservers();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('visibilitychange', function () {
    registeredVideos.forEach(function (video) {
      if (document.hidden) {
        pause(video);
      } else if (!video.hasAttribute('data-video-manual') && isInViewport(video)) {
        play(video);
      }
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('video[data-deferred-video]').forEach(function (video) {
      if (loadObserver) loadObserver.unobserve(video);
      if (playObserver) playObserver.unobserve(video);
      pause(video);
      registeredVideos.delete(video);
      observedVideos.delete(video);
    });
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', rebuildObservers);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(rebuildObservers);
  }
})();
